export default "__VITE_ASSET__BaaAYv$V__"